import { call } from 'redux-saga/effects'
import Account, { sagas } from './Account/index'
import createDuck from '../baseDuck'

sagas.newsletterSubscribe = function* newsletterSubscribe(payload) {
    yield call(sagas.newsletterSubscribe, payload)
}

const account = Account({
    createDuck,
    sagas,
})

export default account
